"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RiskLevel = function (props) {
    var classes = ['RiskLevel'];
    var level = props.risklevel;
    if (level !== null && level !== undefined && level >= props.required_risklevel) {
        return React.createElement("div", { className: classes.join(" "), style: { backgroundColor: props.color } });
    }
    return React.createElement("div", { className: classes.join(" ") });
};
var RiskLevelIndicator = function (props) {
    var risklevel = [];
    var colors = props.risklevel.opportunity ? props.risklevel.opp_colors : props.risklevel.risk_colors;
    for (var i = 0; i < colors.length; i++) {
        var color = colors[i];
        risklevel.push(React.createElement(RiskLevel, { risklevel: props.risklevel.level, required_risklevel: parseInt(color.value), opportunity: props.risklevel.opportunity, color: color.color }));
    }
    return (React.createElement("div", { className: "RiskLevelIndicator" }, risklevel));
};
exports.default = RiskLevelIndicator;
